/**
 * Config set assignment state for generic sensors
 *
 * @readonly
 * @enum {string}
 */
export const ConfigSetAssignmentState = Object.freeze({
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
})
